<template>
  <div id="insec-data">
    <div class="insecData-all">
      <div class="insecData-title">
        <div class="insecTitle-left">
          <span class="insecTitle-left-container">杀虫灯</span>
        </div>
        <div class="insecTitle-right">
          <div class="insecTitle-right-container">
            设备名
            <el-select @change="fxSetChange($event)" v-model="fxDevice" filterable >
              <el-option :key="item.id" :label="item.name" :value="item.id" v-for="item in fxOptionList" >
                <span :class="item.state === 'red' ? 'red-circle' : 'green-circle'"></span>
                {{ item.name }}
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="insecData-container" :style="fxFlg == true ? '' : 'pointer-events: none; '">
        <div class="insecData-containerAll">
          <dv-border-box12>
            <div class="insecData-top">
              <span class="insecData-top-container">风吸参数设置</span>
            </div>

            <div class="insecData-content">
              <div class="insecContent-top">
                <div class="insecTop-main" >
                  <div class="insecTop-main-title" >开关状态</div>
                  <div class="insecTop-title-state">
                    <span class="insecTop-title-stateContainer" @click="switchOpenClose">{{switchName}}</span>
                  </div>
                </div>
                <div class="insecTop-main" >
                  <div  class="insecTop-main-title" >控制方式</div>
                  <div class="insecTop-main-select" >
                    <el-select @change="selectVersion($event)" v-model="version" placeholder="请选择" :popper-append-to-body="false">
                      <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <div class="insecContent-middle">
                <div class="insecMiddle-main">
                  <div class="insecMiddle-main-title">开启时长</div>
                  <div class="insecMiddle-main-input">
                    <span class="insecMiddleMain-input-data"><el-input type="number" placeholder="0" v-model="openTime" @change="openTimeInput"/></span>
                    <span class="insecMiddleMain-input-tag">(1~500)</span>
                  </div>
                </div>
                <div class="insecMiddle-main">
                  <div class="insecMiddle-main-title">定时开启(时)</div>
                  <div class="insecMiddle-main-input">
                    <span class="insecMiddleMain-input-data"><el-input type="number" placeholder="0" v-model="hourOpenTime" @change="hourOpenTimeInput"/></span>
                    <span class="insecMiddleMain-input-tag">(0~23)</span>
                  </div>
                </div >
                <div class="insecMiddle-main">
                  <div class="insecMiddle-main-title">定时开启(分)</div>
                  <div class="insecMiddle-main-input">
                    <span class="insecMiddleMain-input-data"><el-input type="number" placeholder="0" v-model="minOpenTime" @change="minOpenTimeInput"/></span>
                    <span class="insecMiddleMain-input-tag">(0~59)</span>
                  </div>
                </div>
              </div>

              <div class="insecContent-middle">
                <div class="insecMiddle-main">
                  <div class="insecMiddle-main-title">上传周期</div>
                  <div class="insecMiddle-main-input">
                    <span class="insecMiddleMain-input-data"><el-input type="number" placeholder="0" v-model="sleepTime" @change="sleepTimeInput"/></span>
                    <span class="insecMiddleMain-input-tag">(1~180)</span>
                  </div>
                </div>
                <div class="insecMiddle-main">
                  <div class="insecMiddle-main-title">光控开启电压</div>
                  <div class="insecMiddle-main-input">
                    <span class="insecMiddleMain-input-data"><el-input type="number" placeholder="0" v-model="openVoltage" @change="openVoltageInput"/></span>
                    <span class="insecMiddleMain-input-tag">(0~33)</span>
                  </div>
                </div>
                <div class="insecMiddle-main">
                  <div class="insecMiddle-main-title">光控延时时间</div>
                  <div class="insecMiddle-main-input">
                    <span class="insecMiddleMain-input-data"><el-input type="number" placeholder="0" v-model="openDelaytime" @change="openDelayTimeInput"/></span>
                    <span class="insecMiddleMain-input-tag">(1~180)</span>
                  </div>
                </div>
              </div>
              <div class="insecContent-bottom">
                <!--                <el-button type="primary" @click="btnOpen">开&nbsp;&nbsp;启</el-button>-->
                <el-button type="primary" @click="commit">设&nbsp;&nbsp;置</el-button>
                <!--                <el-button type="primary" @click="btnClose">关&nbsp;&nbsp;闭</el-button>-->
              </div>
            </div>
          </dv-border-box12>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import moment from 'moment'
  import {
    getAttributesClient,
    getAttributesServer,
    getCredentials,
    postAttributesClient
  } from "../../until/api/MeteSoil";
  export default {
    name: 'InsecControl',
    components: {},
    data() {
      return {
        fxOption: [],
        fxOptionList: [],
        fxDevice: '',
        openTime: 240,
        sleepTime: 1,
        hourOpenTime: 18,
        minOpenTime: 0,
        openVoltage: 14,
        openDelaytime: 30,
        switchFlg: 3,
        switchName: '开启',
        options: [{
          value: 2,
          label: '光控'
        }, {
          value: 3,
          label: '时控'
        }],
        version:2,
        fxCredentialsId:'',
        deviceInfo: {},
        fxFlg: false,
        fxJson: {},
        time: 0,
      }
    },

    beforeDestroy() {
    },

    mounted() {
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      let customerId = this.$route.params.customerId === undefined ?this.$commonFun.unCompileStr(localStorage.getItem('customerId') ) : this.$route.params.customerId;

      let that = this;
      this.$MeteSoilCommon.getDeviceList(authority, customerId, function (deviceList) {
        that.fxDeviceBoards(deviceList);
      })
    },

    methods: {
      fxDeviceBoards(response) {
        if(response.data.length === 0) return;
        let promises = [];
        for(let i = 0; i < response.data.length; i++) {
          let fxJson = {
            id: response.data[i].id.id,
            name: response.data[i].name,
            type: response.data[i].id.entityType
          }

          let promise = this.$MeteSoilCommon.getLastConnectTime(fxJson.type, fxJson.id).then(time => {
            let beforeTime = new Date(moment().subtract(1, "hours")).getTime();
            fxJson.state = time < beforeTime ? 'red' : 'green';
            return fxJson;
          });

          promises.push(promise);
        }

        Promise.all(promises).then(result => {
          this.fxOption = result;
          if(this.fxOption.length > 0) {
            this.fxInsecDevice(0, this.fxOption.length);
          }
        })
      },

      fxInsecDevice(j, length) {
        let that = this;
        this.$MeteSoilCommon.getCredentialsInfo(this.fxOption[j].id, function (deviceInfo) {
          that.$MeteSoilCommon.getDeviceKeyList(deviceInfo, function (keyData) {
            that.fxKeyOperate(j, keyData);
            if(++j < length) {
              that.fxInsecDevice(j, length);
            }
          })
        })
      },

      fxKeyOperate(j, keyData) {
        let strKey = '';
        let keyList = keyData.split(',');
        for(let i = 0; i < keyList.length; i++) {
          if(keyList[i].indexOf('fxd_') >= 0) {
            i == keyList.length - 1 ? strKey += keyList[i] : strKey += keyList[i] + ',';
          }
        }

        if(strKey != '') {
          this.fxOptionList.push(this.fxOption[j]);
          if(this.fxDevice == '') {
            this.fxDevice = this.fxOption[0].id;
            this.getFxDeviceInfo();
          }
        }
      },

      fxSetChange(event) {
        this.fxDevice = event;
        this.getFxDeviceInfo();
      },

      getFxDeviceInfo() {
        this.fxFlg = false;
        getCredentials(this.fxDevice).then(response => {
          this.fxCredentialsId = response.data.credentialsId;
          this.deviceInfo = response.data.deviceId;
          this.getFxFlg();
        }).catch(error => {
          console.log("error", error)
        })
      },

      getFxFlg() {
        getAttributesServer(this.deviceInfo.entityType, this.deviceInfo.id).then(response => {
          for(let i = 0; i < response.data.length; i++){
            if(response.data[i].key == 'fx') {
              this.fxFlg = true;
              this.fxGetClientInfo();
              break;
            }
          }
        }).catch(error => {
          console.log("error", error);
        })
      },

      openTimeInput(value) {
        let min = 1;
        let max = 500;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "开启时长范围在1~500之间"
          });
        }
        if(value < min) {
          this.openTime = min;
        } else if(value > max) {
          this.openTime = max;
        }

        this.openTime = Math.floor(this.openTime);
      },

      sleepTimeInput(value) {
        let min = 1;
        let max = 180;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "上传周期范围在1~180之间"
          });
        }
        if(value < min) {
          this.sleepTime = min;
        } else if(value > max) {
          this.sleepTime = max;
        }

        this.sleepTime = Math.floor(this.sleepTime);
      },

      hourOpenTimeInput(value) {
        let min = 0;
        let max = 23;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "定时开启(时)范围在0~23之间"
          });
        }
        if(value < min) {
          this.hourOpenTime = min;
        } else if(value > max) {
          this.hourOpenTime = max;
        }

        this.hourOpenTime = Math.floor(this.hourOpenTime);
      },

      minOpenTimeInput(value) {
        let min = 0;
        let max = 59;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "定时开启(分)范围在0~59之间"
          });
        }
        if(value < min) {
          this.minOpenTime = min;
        } else if(value > max) {
          this.minOpenTime = max;
        }

        this.minOpenTime = Math.floor(this.minOpenTime);
      },

      openVoltageInput(value) {
        let min = 0;
        let max = 33;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "光控开启电压范围在0~33之间"
          });
        }
        if(value < min) {
          this.openVoltage = min;
        } else if(value > max) {
          this.openVoltage = max;
        }

        this.openVoltage = Math.floor(this.openVoltage);
      },

      openDelayTimeInput(value) {
        let min = 1;
        let max = 180;
        if(value < min || value > max) {
          this.$message({
            showClose: true,
            type: "warning",
            message: "光控延时时间范围在1~180之间"
          });
        }
        if(value < min) {
          this.openDelaytime = min;
        } else if(value > max) {
          this.openDelaytime = max;
        }

        this.openDelaytime = Math.floor(this.openDelaytime);
      },

      selectVersion(event) {
        this.version = event;
      },

      commit() {
        this.setFxJson();
        this.fxSetClintInfo();
      },

      switchOpenClose() {
        if(this.switchName == '开启') {
          this.switchFlg = 0;
          this.switchName = "关闭"
        } else {
          this.switchFlg = 1;
          this.switchName = "开启"
        }

        this.time =  Math.floor(Date.now() / 1000);
        this.setFxJson();
        this.fxSetClintInfo();
      },

      setFxJson() {
        this.fxJson.op_fl = this.switchFlg;
        this.fxJson.op_t = parseInt(this.openTime);
        this.fxJson.h_op_t = parseInt(this.hourOpenTime);
        this.fxJson.m_op_t = parseInt(this.minOpenTime);
        this.fxJson.sT = parseInt(this.sleepTime);
        this.fxJson.opVol = parseInt(this.openVoltage);
        this.fxJson.opDt = parseInt(this.openDelaytime);
        this.fxJson.ver = this.version;
        if(this.time != 0) {
          this.fxJson.time = this.time;
        }
      },

      fxGetClientInfo() {
        getAttributesClient(this.fxCredentialsId).then(response => {
          this.switchFlg = 3;
          this.switchName = "开启";
          this.openTime = 240;
          this.hourOpenTime = 18;
          this.minOpenTime = 0;
          this.sleepTime = 1;
          this.openVoltage = 14;
          this.openDelaytime = 30;
          this.version = 2;
          this.time = 0;
          if(response.data.client != undefined) {
            for(let obj in response.data.client) {
              if(obj === 'cmd') {
                let json = JSON.parse(response.data.client[obj]);
                this.switchFlg = json.op_fl;
                if(json.op_fl == 1) {
                  this.switchName = '开启';
                } else {
                  this.switchName = '关闭';
                }
                this.openTime = json.op_t;
                this.hourOpenTime = json.h_op_t;
                this.minOpenTime = json.m_op_t;
                this.sleepTime = json.sT;
                this.openVoltage = json.opVol;
                this.openDelaytime = json.opDt;
                json.time === undefined ? this.time = 0 : this.time = json.time;
                this.version = json.ver;
              }
            }
          }
        }).catch(error => {
          console.log("error", error)
        })
      },

      fxSetClintInfo() {
        let cmdJson = {};
        cmdJson.cmd = JSON.stringify(this.fxJson);
        postAttributesClient(this.fxCredentialsId, cmdJson).then(response => {
          this.$message({
            showClose: true,
            type: "warning",
            message: "设置成功"
          })
        }).catch(error => {
          this.$message({
            showClose: true,
            type: "warning",
            message: "设置失败"
          })
        })
      }
    }
  }
</script>

<style lang="less">
  @import "../less/InsecControl";
</style>

<style>
  .red-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: red;
    border-radius: 50%;
    margin-right: 5px;
  }

  .green-circle {
    display: inline-block;
    width: 10px;
    height: 10px;
    background-color: green;
    border-radius: 50%;
    margin-right: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/InsecControl.vue